import CryptoJS from 'crypto-js'

export const encryptData = (data: any, secretKey: any) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString()
}

export const decryptData = (ciphertext: any, secretKey: any) => {
    const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey)
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8)
    return JSON.parse(decryptedData)
}

export const saveToSessionStorage = (key: any, data: any, secretKey: any) => {
    const encryptedData = encryptData(data, secretKey)
    sessionStorage.setItem(key, encryptedData)
}

export const getFromSessionStorage = (key: any, secretKey: any) => {
    const encryptedData = sessionStorage.getItem(key);
    if (!encryptedData)
        return null;
    return decryptData(encryptedData, secretKey);
}